import React, { useContext, useEffect, useState, Fragment } from "react";
import ChatMiddleware from "./ChatMiddleware";
import { useDispatch, useSelector } from "react-redux";
import {
  setThemeColor,
  onGetPwaUserConfig,
  setThemeType,
} from "../../appRedux/actions";
import { switchLanguage } from "../../appRedux/actions/Setting";
import languageData from "../Topbar/languageData";
import { useReactOidc } from "@axa-fr/react-oidc-context";
import AddToHomeScreen from "@ideasio/add-to-homescreen-react";

export default function ThemeMiddleware(props: any) {
  const dispatch = useDispatch();

  let pwaTheme = localStorage.getItem("pwaTheme") as string;

  const userConfig = useSelector(({ userConfig }: any) => userConfig);
  const settings = useSelector(({ settings }: any) => settings);

  const handleColorChange = (filename: string) => {
    let link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.className = "gx-style";
    link.href = `/css/${filename}.css`;
    document.body.appendChild(link);
    dispatch(setThemeColor(filename));
  };

  useEffect(() => {
    if (
      userConfig.pwaUserConfig.pwaTheme &&
      settings.themeColor !== userConfig.pwaUserConfig.pwaTheme
    ) {
      handleColorChange(pwaTheme);
    }
  }, [userConfig]);

  useEffect(() => {
    if (!userConfig.getThemeColor && !pwaTheme) {
      dispatch(onGetPwaUserConfig());
    }

    if (pwaTheme && settings.themeColor !== pwaTheme) {
      handleColorChange(pwaTheme);
    }
  }, []);

  let language = localStorage.getItem("language") as string;

  useEffect(() => {
    //   if (
    //     userConfig.pwaUserConfig.lang &&
    //     userConfig.pwaUserConfig.lang !== language
    //   ) {
    //     let languageProps =
    //       language === "en-US" ? languageData[1] : languageData[0];

    //     dispatch(switchLanguage(languageProps));
    //   }

    if (language) {
      let languageProps =
        language === "en-US" ? languageData[1] : languageData[0];
      let locale = settings.locale.locale;

      if (locale !== languageProps.locale) {
        dispatch(switchLanguage(languageProps));
      }
    }
  }, []);

  return (
    <Fragment>
      <AddToHomeScreen
        appId="Add-To-Homescreen-FG-PWA"
        customPromptContent={{
          // title:
          //   "Do you want to install Add-to-homescreen React Modified Behavior Example on your homescreen?",
          title:
            "آیا مایل هستید که نسخه pwa فراگستر را به اپلیکشین های خود اضافه کنید",
          cancelMsg: "",
          installMsg: "Install",
          src: "icons/loader.svg",
        }}
        customPromptElements={{
          container: "athContainer",
          containerAddOns: "",
          banner: "athBanner",
          logoCell: "athLogoCell",
          logoCellAddOns: "athContentCell",
          logo: "athLogo",
          titleCell: "athTitleCell",
          titleCellAddOns: "athContentCell",
          title: "athTitle",
          cancelButtonCell: "athCancelButtonCell",
          cancelButtonCellAddOns: "athButtonCell",
          cancelButton: "athCancelButton",
          installButtonCell: "athInstallButtonCell",
          installButtonCellAddOns: "athButtonCell",
          installButton: "athInstallButton",
          installButtonAddOns: "button",
          guidance: "athGuidance",
          guidanceImageCell: "athGuidanceImageCell",
          guidanceImageCellAddOns: "",
          guidanceCancelButton: "athGuidanceCancelButton",
        }}
      />
      <ChatMiddleware {...props} />
    </Fragment>
  );
}
